import {isEmpty} from 'lodash'
export function getAticleColumns() {
    let columns = JSON.parse(localStorage.getItem('articleColumns'))
    if (!isEmpty(columns)) {
        return columns
    }
     return ['checkbox','_id', 'title', 'sub_title', 'description', 'authors', 'publication', 'pub_date', 'publishers', 'settings']
}

export function getTableOptions() {
    return {
        filterByColumn: false,
        perPage:10,
        pagination: { show: false},
        filterable: false,
        headings: {
            title : 'Title',
            _id: 'GUID',
            sub_title: 'Sub Title',
            description : 'Description',
            authors: 'Authors',
            publication: 'Publication',
            pub_date: 'Publication Date',
            publishers: 'Publisher',
            checkbox: 'checkbox'
          },
          sortable: ['no'],
          sortIcon: { base: 'as-nova', up: 'nova-tablesortinga-z', down: 'nova-tablesortingz-a', is: 'nova-tablesorting' },
    }
}
export function getArticleTableSettingsOptions() {
    return [
           {key: 'checkbox', value: ('Checkbox') },
           {key: '_id', value: ('GUID')},
           {key: 'title', value: ('Title')},
           {key: 'sub_title', value: ('Subtitle')},
           {key: 'description', value: ('Description')},
           {key: 'authors', value: ('Author(s)')},
           {key: 'publication', value: ('Publication')},
           {key: 'pub_date', value: ('Publication Date')},
           {key: 'publishers', value: ('Publisher')},
           {key: 'settings', value: ('Settings')},
    ]
    
}